// NOSONAR
// contains third party service code, required by OP

import { parse } from 'cookie';
import { isArray, isPlainObject } from 'lodash';

export const mockGiosgChat = () => {
  window._giosg = (fn) => typeof fn === 'function' && fn();
  window.giosg = {
    api: {
      shoppingCart: {
        submit: (...props) => {
          console.log('submit', ...props);
        },
        clearCart: (...props) => {
          console.log('clearCart', ...props);
        },
        freeze: (...props) => {
          console.log('freeze', ...props);
        },
      },
    },
  };
};

let chatLaunched = false;

/**
 * Checks if the user has consented to tracking cookies.
 * @returns {boolean}
 */
const areTrackingCookiesConsented = () => {
  try {
    const parsedCookie = parse(document.cookie);
    if (!isPlainObject(parsedCookie)) {
      return false;
    }
    const consentCookieValue =
      parsedCookie['op.authConsent'] || parsedCookie['op.anoConsent'];
    if (!consentCookieValue) {
      return false;
    }
    const consentCookie = JSON.parse(consentCookieValue);
    if (!consentCookie || !isArray(consentCookie.categories)) {
      return false;
    }
    return consentCookie.categories.every((value) => value === 1);
  } catch (e) {
    console.log('Failed to read cookie consent value:');
    console.log(e);
    return false;
  }
};

/**
 * Injects the giosg script into the HTML document or mocks it.
 * @param {string} id
 * @param {boolean} isDev
 */
export const launchGiosgChat = (id, isDev, isContentOnly) => {
  if (!areTrackingCookiesConsented() && !isDev) {
    return;
  }

  if (isContentOnly) {
    return;
  }

  if (isDev) {
    mockGiosgChat();
    return;
  }

  if (chatLaunched) {
    return;
  }

  /* eslint-disable */
  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = `${window.__RHVKLSO002_CONFIG.GIOSG_URL}${window.__RHVKLSO002_CONFIG.GIOSG_PATH}/${id}`;
    if (!window._giosg) {
      window._giosg = function () {
        if (!window._giosg._e) {
          window._giosg._e = [];
        }
        // eslint-disable-next-line prefer-rest-params
        window._giosg._e.push(arguments);
      };
    }
    window._giosg._c = id;
    window._giosg._h = window.__RHVKLSO002_CONFIG.GIOSG_URL;
    const n = document.getElementsByTagName('script')[0];
    n.parentNode?.insertBefore(script, n);
  } catch (err) {
    console.log('Giosg chat error:', err.message);
    return;
  }

  chatLaunched = true;
  /* eslint-enable */
};
